import { create } from 'zustand';
import { Asset, ConfiguredTemplate, ExtractedData } from '../types/dataInputTypes';
import { toast } from 'react-toastify';
import { t as i18nT } from 'i18next';

interface OcrInputState {
  selectedAsset: Asset | null;
  selectedTemplate: ConfiguredTemplate | null;
  extractedData: ExtractedData[] | null;
  processedImageUrl: string | null;
  originalImageUrl: string | null;
  dataInputId: string | null;
  selectedDateTime: number | null;

  setSelectedDateTime: (dateTime: number | null) => void;
  setSelectedAsset: (asset: Asset | null) => void;
  setSelectedTemplate: (template: ConfiguredTemplate | null) => void;
  setProcessingSuccess: (data: {
    extractedData: ExtractedData[];
    processedImageUrl: string;
    originalImageUrl: string;
    dataInputId: string;
  }) => void;
  updateExtractedValueByPath: (path: (string | number)[], newValue: string | number) => void;
  resetOcrData: () => void;
  resetAll: () => void;
}

const getInitialState = () => ({
  selectedAsset: null,
  selectedTemplate: null,
  extractedData: null,
  processedImageUrl: null,
  originalImageUrl: null,
  dataInputId: null,
  selectedDateTime: Date.now(),
});

export const useOcrInputStore = create<OcrInputState>((set) => ({
  ...getInitialState(),

  setSelectedDateTime: (dateTime) => set({ selectedDateTime: dateTime }),

  setSelectedAsset: (asset) => set({ selectedAsset: asset }),

  setSelectedTemplate: (template) => set({ selectedTemplate: template }),

  setProcessingSuccess: (data) =>
    set({
      extractedData: data.extractedData,
      processedImageUrl: data.processedImageUrl,
      originalImageUrl: data.originalImageUrl,
      dataInputId: data.dataInputId,
    }),

  updateExtractedValueByPath: (path, newValue) =>
    set((state) => {
      if (!state.extractedData) return {};
      const newExtractedData = JSON.parse(JSON.stringify(state.extractedData));
      try {
        let currentLevel: any = newExtractedData;
        const finalKey = path[path.length - 1];
        for (let i = 0; i < path.length - 1; i++) {
          currentLevel = currentLevel[path[i]];
        }
        currentLevel[finalKey].value = newValue;
        return { extractedData: newExtractedData };
      } catch (e) {
        toast.error(i18nT('ocrDataInput.updateFailed', 'Failed to update'));
        return {};
      }
    }),

  resetOcrData: () =>
    set({
      extractedData: null,
      processedImageUrl: null,
      originalImageUrl: null,
      dataInputId: null,
      selectedDateTime: Date.now(),
    }),

  resetAll: () => set(getInitialState()),
}));
